export default __webpack_public_path__ + "media/zurb/img/ecommerce/loyalty_3-1661135b82f02aace5d3dc167d53b530.png";